import { adsRoot } from './ads-root';
import { homeRoot } from './home-root';
import { socialRoot } from './social-root';
import { myWebsite } from './my-website';

export const unifiedSmartPages = [adsRoot, homeRoot, socialRoot, myWebsite];
